export default {
  isJsonString (str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },
  safeParse(str) {
    try {
      return JSON.parse(str) || {}
    } catch (e) {
      return {}
    }
  }
}
